import { __assign } from 'tslib';
import React__default, { useEffect } from 'react';
import clsx from 'clsx';
import { logger } from '../../util/_internal/logger.js';
import { propTypes, defaultProps } from './Switch.types.js';
import styles from './Switch.module.scss.js';

/** Boolean input. Preferred in 'enable/disable' situations. */
var Switch = function (props) {
    var checked = props.checked, disabled = props.disabled, withText = props.withText, textWhenChecked = props.textWhenChecked, textWhenUnchecked = props.textWhenUnchecked, testId = props.testId, buttonProps = props.buttonProps;
    useEffect(function () {
        if (testId) {
            logger.warn('DEPRECATION WARNING: The `testId` prop is deprecated and support for it will be removed soon. Please use `data-testid` instead.');
        }
        if (withText) {
            logger.warn('DEPRECATION WARNING: The `withText` prop is deprecated and support for it will be removed soon.');
        }
        if (textWhenChecked) {
            logger.warn('DEPRECATION WARNING: The `textWhenChecked` prop is deprecated and support for it will be removed soon.');
        }
        if (textWhenUnchecked) {
            logger.warn('DEPRECATION WARNING: The `textWhenUnchecked` prop is deprecated and support for it will be removed soon.');
        }
    }, []);
    var handleChange = function () {
        props.onChange(!props.checked);
    };
    var renderSlider = function () {
        var checked = props.checked, withText = props.withText, textWhenChecked = props.textWhenChecked, textWhenUnchecked = props.textWhenUnchecked, testId = props.testId;
        return (React__default.createElement("span", { className: clsx(styles.Slider, checked && styles.Slider___checked, !withText && styles.Slider___basic, checked && !withText && styles.Slider___right), "data-testid": "visible-".concat(props['data-testid'] || testId) }, withText && (React__default.createElement("span", { className: clsx(styles.Slider_text, checked && styles.Slider_text___checked, !withText && styles.Slider_text___basic) }, checked ? textWhenChecked : textWhenUnchecked))));
    };
    var labelClassName = clsx(styles.Switch, styles.Switch_button, disabled && styles.Switch___disabled, !withText && styles.Switch___basic);
    return (React__default.createElement("button", __assign({ className: labelClassName, type: "button", role: "switch", "aria-checked": checked, "data-testid": props['data-testid'] || testId, onClick: handleChange, disabled: disabled }, buttonProps), renderSlider()));
};
Switch.propTypes = propTypes;
Switch.defaultProps = defaultProps;
Switch.displayName = 'Switch';

export { Switch, Switch as default };
